var sliders = document.querySelectorAll(".acf-slider");
sliders.forEach(function (slider) {
	if ("IntersectionObserver" in window) {
		var carousel = slider.querySelector('[aria-label="carousel"]');
		var slides = slider.querySelectorAll(".acf-slide");

		var observerSettings = {
			root: carousel,
			rootMargin: "-20px",
		};

		carousel.classList.add("js-active");

		Array.prototype.forEach.call(slides, function (slide, index) {
			// console.log(index);
			var slide_link = slide.querySelector("a");
			if (slide_link) {
				slide_link.setAttribute("tabindex", "-1");
			}
		});

		var scrollIt = function scrollIt(slideToShow) {
			var scrollPos =
				Array.prototype.indexOf.call(slides, slideToShow) * Math.floor(carousel.scrollWidth / slides.length);

			if (carousel.scrollLeft === scrollPos) {
				carousel.scrollLeft = scrollPos;
				scrollPos = scrollPos - slideToShow.clientWidth;
			}
			carousel.scrollLeft = scrollPos;
		};

		var showSlide = function showSlide(dir, slides) {
			var visible = carousel.querySelectorAll(".acf-slide.visible");
			var i = dir === "previous" ? 0 : 1;

			if (visible.length > 1) {
				scrollIt(visible[i]);
			} else {
				var newSlide = i === 0 ? visible[0].previousElementSibling : visible[0].nextElementSibling;
				if (newSlide) {
					scrollIt(newSlide);
				}
			}
		};

		var callback = function callback(slides, observer) {
			Array.prototype.forEach.call(slides, function (entry) {
				entry.target.classList.remove("visible");
				var link = entry.target.querySelector("a");
				if (link) {
					link.setAttribute("tabindex", "-1");
				}
				if (!entry.intersectionRatio > 0) {
					return;
				}

				entry.target.classList.add("visible");

				if (link) {
					link.removeAttribute("tabindex", "-1");
				}
			});
		};

		var observer = new IntersectionObserver(callback, observerSettings);
		Array.prototype.forEach.call(slides, function (t) {
			return observer.observe(t);
		});

		var controls = document.createElement("ul");
		controls.classList.add("controls");
		controls.setAttribute("aria-label", "carousel controls");
		controls.innerHTML =
			'\n    <li><button type="button" class="previous" data-direction="previous" aria-label="previous">\n      <svg aria-hidden="true" focusable="false"><use xlink:href="#slider-arrow-left"></use></svg>\n    </button></li>\n    <li><button type="button" class="next" data-direction="next" aria-label="next">\n      <svg aria-hidden="true" focusable="false"><use xlink:href="#slider-arrow-right"/></svg>\n    </button></li>\n    ';
		carousel.parentNode.insertBefore(controls, carousel.nextElementSibling);

		// var buttons = controls.querySelectorAll("button");
		// buttons.forEach(function (button) {
		// 	button.addEventListener("click", function (e) {
		// 		showSlide(button.dataset.direction, slides);
		// 	});
		// });

		controls.addEventListener("click", function (e) {
			showSlide(e.target.closest("button").dataset.direction, slides);
		});
	}
});
